import { escapeHTML } from '../services/sanitize.js';
import { icon } from '../services/icons.js';

export const number = value => new Intl.NumberFormat('en-US').format(Number(value) || 0);
export const dateTime = value => value ? new Date(`${String(value).replace(' ', 'T')}Z`).toLocaleString('en-US', { dateStyle: 'medium', timeStyle: 'short' }) : '—';
export const titleCase = value => String(value || '').replaceAll('_', ' ').replace(/\b\w/g, letter => letter.toUpperCase());

const items = [
  ['/admin', 'Overview', 'chart'],
  ['/admin/quizzes', 'Quizzes', 'lightBulb'],
  ['/admin/sessions', 'Sessions', 'bolt'],
  ['/admin/hosts', 'Hosts', 'trophy'],
  ['/admin/system', 'System', 'cog']
];

export const adminFrame = ({ active, eyebrow, title, subtitle, actions = '', content }) => `
  <section class="admin-page admin-area">
    <div class="admin-layout">
      <aside class="admin-sidebar">
        <div class="admin-sidebar-label">ADMIN</div>
        <nav aria-label="Admin navigation">${items.map(([href,label,iconName]) => `<a href="#${href}" class="${active === href ? 'active' : ''}" ${active === href ? 'aria-current="page"' : ''}>${icon(iconName)}<span>${label}</span></a>`).join('')}</nav>
      </aside>
      <div class="admin-content">
        <header class="admin-page-head"><div><span>${escapeHTML(eyebrow)}</span><h1>${escapeHTML(title)}</h1><p>${escapeHTML(subtitle)}</p></div>${actions}</header>
        ${content}
      </div>
    </div>
  </section>`;

export const adminError = error => `<div class="admin-error"><strong>Unable to load this page</strong><p>${escapeHTML(error.message)}</p><a class="btn btn-secondary" href="#/admin">Back to overview</a></div>`;
export const loading = label => `<div class="admin-loading">Loading ${escapeHTML(label)}…</div>`;
export const statusBadge = status => `<span class="admin-status ${escapeHTML(status)}">${status === 'finished' ? 'Finished' : status === 'lobby' ? 'Lobby' : 'In progress'}</span>`;
